/** React's window onto a panel store's revision counter. */

import { useSyncExternalStore } from 'react'
import type { PanelState } from '../../tools/PanelState'

export function usePanelRevision(state: PanelState): number {
  return useSyncExternalStore(state.subscribe, state.revision)
}
